import React, { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl'
import classnames from 'classnames';

import { LineItemCount } from "../components/LineItems";
import TrackingEvents from '../components/TrackingEvents';
import { BtLink } from '../components/BtLink';
import { useFeatureEnables } from '../dataProviders';

import { CardSection } from './Card';
import { LineItemClasses, TrackingClassses } from './ShipmentActivityContent';
import LineItemsCard from './LineItemsCard';


interface TabbedClasses {
  root?: string,
  lineItemsCard: string,
  shipmentActivity?: string,
  scrollableSection?: string,
  marker?: string,
  eventRow?: string,
  shipmentTabs?: string,
  tab?: string,
  activeTab?: string
  inactiveTab?: string
  leftTab?: string
  rightTab?: string
}


export default function TabbedShipmentActivityContent({classes, trackingClasses, lineItemClasses, isGiftWrapped, lineItemsCardShown}:{
  classes: TabbedClasses,
  trackingClasses: TrackingClassses,
  lineItemClasses: LineItemClasses,
  isGiftWrapped: Boolean,
  lineItemsCardShown: Boolean
}) {

  const intl = useIntl();
  const { showGiftLink } = useFeatureEnables();

  const formatTimestamp = (timestamp: Date) => {
    const date = intl.formatDateToParts(timestamp, { day: 'numeric', month: 'long' }).map( p => p.value ).join('');
    const time = intl.formatDateToParts(timestamp, { hour: 'numeric', minute: 'numeric' }).map( p => p.value ).join('');
    return `${date} - ${time}`;
  };

  const eventClassName = (index: number) => (
    classnames(classes.eventRow, { 'mostRecentEvent': index === 0 })
    );

  const [showActivity, setShowActivity] = useState(true);
  const toggleShowActivity = useCallback( () => setShowActivity(true), [] );
  const toggleShowContent = useCallback( () => setShowActivity(false), [] );


  return ( 
    <div className={classes.root}> 
      <div className={classes.shipmentTabs}>
        <BtLink className={`${classes.tab} ${classes.leftTab} ${showActivity ? classes.activeTab : classes.inactiveTab} `} onClick={toggleShowActivity}>
          { (isGiftWrapped) ? (
            <FormattedMessage description="layout03.shipmentTabs.activityAsGift" defaultMessage="Gift Activity" />
          ):(
            <FormattedMessage description="layout03.shipmentTabs.activity" defaultMessage="Shipment Activity" />
          )}
        </BtLink>
        { lineItemsCardShown &&
          <BtLink className={`${classes.tab} ${classes.rightTab} ${ !showActivity ? classes.activeTab : classes.inactiveTab}`}  onClick={toggleShowContent}>
            <FormattedMessage description="layout03.shipmentTabs.content" defaultMessage="Shipment Contents" />
            {" ("}
            <LineItemCount />
            {")"}
          </BtLink>
        }
      </div>
      <div className={classes.shipmentActivity}>
        { (showActivity) &&
          <div className={classes.scrollableSection} role="list">
            <TrackingEvents
              classes={trackingClasses}
              truncateToCount={showGiftLink ? 3 : 4}
              formatTimestamp={formatTimestamp}
              eachEvent={ ({ content,key,index }) => (
                <CardSection className={eventClassName(index)} key={key}>
                  {content}
                </CardSection>
              )}
            />
          </div>
        }
        { (lineItemsCardShown) && (!showActivity ) &&
          <LineItemsCard className={classes.lineItemsCard} lineItemClasses={lineItemClasses} />
        }
      </div>
    </div>
  )
}